<p-dialog
  #fastServico
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">Adicionar serviço</span>
      <i class="pi pi-fw pi-wrench ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Valor</mat-label>
        <input
          matInput
          (keydown)="validateOnlyNumbers($event)"
          type="text"
          [formControl]="form.get('valor')"
          style="text-align: right;"
        />
        <span matPrefix *ngIf="form.get('valor').value">R$&nbsp;</span>
      </mat-form-field>
      <small class="p-error" *ngIf="form.get('valor').hasError('required')">
        {{ displayMessage.valor.required }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('min')">
        {{ displayMessage.valor.min }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('max_value')">
        {{ displayMessage.valor.max_value }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('before_split')">
        {{ displayMessage.valor.before_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('after_split')">
        {{ displayMessage.valor.after_split }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorComma')">
        {{ displayMessage.valor.errorComma }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('errorDots')">
        {{ displayMessage.valor.errorDots }}
      </small>
      <small class="p-error" *ngIf="form.get('valor').hasError('notNumbers')">
        {{ displayMessage.valor.notNumbers }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('valor').hasError('invalidNumber')"
      >
        {{ displayMessage.valor.invalidNumber }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <fast-autocomplete
        #input
        id="field-categoria-servicos"
        placeholder="Categoria do serviço"
        required
        [domain_id]="tokenService.getDomain().id"
        [autoFirst]="false"
        displayField="descricao"
        [value_order]="'descricao'"
        [pageValue]="'0'"
        [pageSizeValue]="'10'"
        [control]="form.get('categoria_servico')"
        (clearSelection)="form.get('categoria_servico').reset()"
        [entityService]="categoriaServicoService"
        [actionState]="checkDisponibilidade('POST', '', '/categoria_servicos')"
        [initDataWithEmpty]="true"
        [insertType]="'categoria_servico'"
        [messages]="{
          duplicate:
            'Já existe um serviço criado com o mesmo nome para a mesma categoria!',
          required: 'Categoria do serviço é obrigatória.',
          typeIs: 'Valor inválido',
          isEmptyValue: 'Inválido: remova os espaços em branco!'
        }"
      ></fast-autocomplete>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
